
define(['jquery', 'underscore', 'underscore.string', 'core', 'component/report/ledger-control', 'app-common/lib/jquery.flexselect', 'common/lib/forms/jquery.caret', 'app-common/lib/jquery.velocity'], function($, _, _s, core, ledgerControl) {
  var controls, createEditControls, editButton, editingCallback, enableDynamicWidth, findControl, findWordLength, getLedgerValue, getNewLedgerSelect, getVendorValue, hideControl, hideLedgerEdit, hideVendorEdit, initKeyboardWatching, isActive, refreshLedgersControl, setLedgerValue, showLedgerEdit, showVendorEdit, simpleEditing, simpleVendorEditControl, tooltipTimeout;
  editingCallback = null;
  controls = {};
  editButton = '.edit-button';
  tooltipTimeout = null;
  simpleEditing = $.browser.msie && ($.browser.version === '8.0' || $.browser.version === '9.0');
  initKeyboardWatching = function() {
    return $(document).unbind('keydown.editing').bind('keydown.editing', function(e) {
      if (isActive() && (e.which || e.keyCode) === 83 && (core.isMac() ? e.metaKey : e.ctrlKey)) {
        e.preventDefault();
        if (typeof editingCallback === "function") {
          editingCallback();
        }
        return false;
      } else {
        return true;
      }
    });
  };
  enableDynamicWidth = function(element) {
    var refreshControlWidth;
    refreshControlWidth = function(extraWidth) {
      var controlWidth;
      controlWidth = findWordLength(findControl(element).val(), element);
      if (extraWidth != null) {
        controlWidth += extraWidth;
      }
      return findControl(element).css('width', controlWidth + 'px');
    };
    refreshControlWidth();
    return findControl(element).bind('dropdownPicked refreshWidth blur', function() {
      return refreshControlWidth();
    }).keyup(function(e) {
      var additionalSpace, update,
        _this = this;
      additionalSpace = e.keyCode === 27 ? 0 : parseInt($(this).css('font-size')) * 2;
      update = function() {
        return refreshControlWidth(additionalSpace);
      };
      return setTimeout(update, 20);
    });
  };
  /*
  # tricky way to find length of word
  */

  findWordLength = function(text, targetElement) {
    var minWidth, textElement, width;
    textElement = $(targetElement).clone().text(text);
    width = null;
    minWidth = 30;
    textElement.css('white-space', 'nowrap');
    textElement.css('font-family', 'Arial, Helvetica, sans-serif');
    $(targetElement).after(textElement);
    width = textElement.width() * 1.18;
    textElement.remove();
    if (width > minWidth) {
      return width;
    } else {
      return minWidth;
    }
  };
  findControl = function(element) {
    var control;
    control = $(element).find("input[type='text'], textarea");
    if (!control.length) {
      control = $(element).find('select');
    }
    return control;
  };
  hideControl = function(value, element, isLedger) {
    var shortened, _ref;
    if (isLedger == null) {
      isLedger = false;
    }
    if (!simpleEditing) {
      findControl(element).trigger('destroy');
    }
    if (isLedger) {
      _ref = ledgerControl.formatLedgerName(value), value = _ref[0], shortened = _ref[1];
    }
    if (shortened) {
      element.addClass('shortened');
    } else {
      element.removeClass('shortened');
    }
    element.removeClass('edit-on');
    return element.html(value);
  };
  hideLedgerEdit = function(value, element) {
    return hideControl(value, $(element), true);
  };
  hideVendorEdit = function(value, element) {
    return hideControl(value, $(element));
  };
  showLedgerEdit = function(data, element, callback, dynamicWidthOff) {
    var ledger, ledgerSelect;
    element = $(element);
    ledger = core.getLedgersById()[data.ledgerAccountId];
    if (!(ledger != null ? ledger.canBeEdited : void 0)) {
      return;
    }
    ledgerSelect = getNewLedgerSelect();
    element.addClass('edit-on');
    element.html(ledgerSelect);
    ledgerSelect.val(data.ledgerAccountId).attr('id', "ledger_for_" + data.id);
    if (!simpleEditing) {
      ledgerSelect.flexselect({
        sortAlphabetically: true
      });
      if (!dynamicWidthOff) {
        enableDynamicWidth(element);
      }
      if (_.isFunction(callback)) {
        findControl(element).bind('dropdownPicked', callback);
        findControl(element).keyup(callback);
      }
      return findControl(element).on('focus', function() {
        return $(this).addClass('highlighted').caretToStart();
      }).on('keyup blur removeHighlight', function() {
        return $(this).removeClass('highlighted');
      });
    } else {
      if (_.isFunction(callback)) {
        return findControl(element).change(callback);
      }
    }
  };
  simpleVendorEditControl = function(element, data) {
    var input;
    input = $("<textarea id='vendor_" + data.transactionId + "'/>");
    element.html(input);
    element.find('textarea').val(_s.trim(data.vendor));
    input.on('keyup', function(e) {
      var newHeight;
      input.height(0);
      newHeight = $.browser.mozilla ? input.prop('scrollHeight') : input.prop('scrollHeight') - parseInt(input.css('font-size'));
      return input.height(newHeight);
    });
    input.keyup();
    return input;
  };
  showVendorEdit = function(data, element, callback, dynamicWidthOff) {
    var input;
    element = $(element);
    element.addClass('edit-on');
    input = simpleVendorEditControl(element, data);
    if (_.isFunction(callback)) {
      return input.change(callback);
    }
  };
  getLedgerValue = function(element) {
    if (simpleEditing) {
      return {
        id: parseInt($(element).find('select').val()),
        name: $(element).find('select option:selected').text()
      };
    } else {
      return {
        id: parseInt($(element).find("input[type='hidden']").val()),
        name: $(element).find("input[type='text']").val()
      };
    }
  };
  setLedgerValue = function(data, element) {
    if (simpleEditing) {
      return $(element).find('select').val(data.id);
    } else {
      $(element).find("input[type='hidden']").val(data.id);
      return $(element).find("input[type='text']").val(data.name);
    }
  };
  getVendorValue = function(element) {
    var control;
    control = findControl(element);
    if (control.length) {
      return _s.trim(control.val());
    } else {
      return void 0;
    }
  };
  isActive = function() {
    return $('.widget').hasClass('edit-on');
  };
  createEditControls = function() {
    var collection, filterByEditable;
    collection = core.getCollection('ledgerAccounts');
    filterByEditable = function(collection) {
      return collection.filter(function(account) {
        return account.isEditable();
      });
    };
    refreshLedgersControl(filterByEditable(collection));
    return collection.off('add remove change').on('add remove change', function() {
      return refreshLedgersControl(filterByEditable(collection));
    });
  };
  refreshLedgersControl = function(ledgers) {
    controls.ledger = $('<select/>');
    return ledgers.forEach(function(ledger) {
      var option;
      option = $('<option/>').attr('value', ledger.get('id')).text(_s.trim(ledger.get('name')));
      return controls.ledger.append(option);
    });
  };
  getNewLedgerSelect = function() {
    return controls.ledger.clone();
  };
  return {
    init: function(descriptions, callback) {
      if (callback != null) {
        editingCallback = callback;
      }
      createEditControls();
      if (!simpleEditing) {
        return initKeyboardWatching();
      }
    },
    on: function(settings) {
      if (settings == null) {
        settings = {};
      }
      $('.widget').addClass('edit-on');
      $(editButton).addClass('active');
      $(editButton).children('.feature-text').text('Save');
      $(editButton).children('.feature-icon').removeClass('ss-write').addClass('ss-gizmo ss-check');
      return $('.edit-feature.edit-button').parent().velocity({
        opacity: 0
      }, {
        duration: 0,
        display: 'none',
        complete: function() {
          return $('.save-feature.edit-button').parent().velocity({
            opacity: 1
          }, {
            duration: 150,
            display: 'inline-block'
          });
        }
      });
    },
    off: function() {
      $('.widget').removeClass('edit-on');
      $(editButton).removeClass('active');
      $(editButton).children('.feature-text').text('Edit');
      $(editButton).children('.feature-icon').removeClass('ss-gizmo ss-check').addClass('ss-gizmo ss-write');
      if (!simpleEditing) {
        clearTimeout(tooltipTimeout);
        $(editButton).tooltip('destroy');
      }
      return $('.save-feature.edit-button').parent().velocity({
        opacity: 0
      }, {
        duration: 100,
        display: 'none',
        complete: function() {
          return $('.edit-feature.edit-button').parent().velocity({
            opacity: 1
          }, {
            duration: 100,
            display: 'inline-block'
          });
        }
      });
    },
    setCallback: function(callback) {
      return editingCallback = callback;
    },
    isActive: isActive,
    showLedgerEdit: showLedgerEdit,
    showVendorEdit: showVendorEdit,
    hideLedgerEdit: hideLedgerEdit,
    hideVendorEdit: hideVendorEdit,
    getLedgerValue: getLedgerValue,
    getVendorValue: getVendorValue,
    setLedgerValue: setLedgerValue,
    getNewLedgerSelect: getNewLedgerSelect,
    hide: function() {
      controls = {};
      editingCallback = null;
      return $(document).unbind('keydown.editing');
    }
  };
});
